var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TaskFilter'),_c('DataTable',{attrs:{"rowKeys":['taskId'],"rows":_vm.tasks,"actions":_vm.readOnly
        ? [
            {
              name: 'workflow',
              label: 'Workflow',
              params: { workflowId: 'workflowId' }
            },
            {
              name: 'task',
              label: 'View',
              params: { taskId: 'taskId' }
            }
          ]
        : [
            {
              name: 'workflow',
              label: 'Workflow',
              params: { workflowId: 'workflowId' }
            },
            {
              name: 'task',
              label: 'View',
              params: { taskId: 'taskId' }
            },
            {
              name: 'taskResultEdit',
              label: 'Update',
              params: { taskId: 'taskId' }
            },
            { name: 'dequeue', label: 'Dequeue', function: _vm.actionDequeueTask }
          ],"columns":[
      { name: 'taskId', type: 'text' },
      { name: 'workflowId', type: 'text' },
      { name: 'workflowType', type: 'text' },
      { name: 'taskType', type: 'text' },
      { name: 'status', type: 'text' },
      { name: 'executionTime', type: 'duration' },
      { name: 'scheduledTime', type: 'date' },
      { name: 'startTime', type: 'date' },
      { name: 'endTime', type: 'date' },
      { name: 'reasonForIncompletion', type: 'text' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }